import { useIntl } from 'react-intl';

import { TOTAL_VISITS_KEY, VisitStatisticTotals } from 'src/features/statistic/types';
import { statisticMessages } from 'src/features/statistic/utils/messages';
import { GeneralBlock } from 'src/registry/components/blocks/GeneralBlock';
import GeneralMessageBlock from 'src/registry/components/blocks/GeneralMessageBlock';
import { SectionBlockTitle } from 'src/registry/components/blocks/SectionBlock';
import { ICON_MAP } from 'src/utils/constants';
import PieChart from 'src/features/statistic/components/chart/PieChart';
import React from 'react';
import { Skeleton } from 'src/registry/ui/Skeleton';
import MapLegend from 'src/features/statistic/components/MapLegend';
import { colorCategoryMapping } from 'src/features/statistic/utils/constants';

type Props = {
    isLoading: boolean;
    data?: VisitStatisticTotals;
};

type FormattedData = {
    title: string;
    value: number;
}[];

export default function WidgetTotalVisits({ isLoading, data }: Props) {
    const { formatMessage } = useIntl();

    const formattedData: FormattedData = React.useMemo(() => {
        if (!data) return [];
        return Object.entries(data)
            .filter(([key, value]) => value > 0 && key !== TOTAL_VISITS_KEY)
            .map(([key, value]) => ({
                title: key,
                value,
            }));
    }, [data]);

    return (
        <GeneralBlock className="min-h-110 flex-1">
            <SectionBlockTitle>{formatMessage(statisticMessages.totalVisits)}</SectionBlockTitle>
            {isLoading ? (
                <Skeleton className="h-90" />
            ) : data ? (
                <div className="flex h-full w-full flex-col justify-center gap-2 px-10">
                    <PieChart
                        data={formattedData}
                        dataKey="value"
                        isLoading={isLoading}
                        title={formatMessage(statisticMessages.totalVisits)}
                        value={data.total_visits_count}
                    />

                    <MapLegend colorMapping={colorCategoryMapping} />
                </div>
            ) : (
                <GeneralMessageBlock
                    icon={ICON_MAP.SEARCH}
                    title={formatMessage(statisticMessages.noPaymentsFound)}
                    subtitle={formatMessage(statisticMessages.chooseDifferentPeriod)}
                />
            )}
        </GeneralBlock>
    );
}
